import React, { useEffect, useState } from "react";
import {
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { t } from "i18next";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

const DisclosureSelection = (props: any) => {
  let [currentDisclosure, setCurrentDisclosure] = useState("");
  let [currentDisclosureIndex, setCurrentDisclosureIndex] = useState<any>(null);

  const addCommentsReasonType = (object: any, e: any) => {
    if (typeof object.comments == "string") {
      object["comments"] = {
        reason: object.comments,
        reasonType: "",
      };
    }
    object["comments"]["reasonType"] = e.target.value;
    props.update();
  };

  useEffect(() => {
    selected = {};
    props.value[1]
      .filter((item: any) => item.included)
      .forEach((el: any) => {
        selected[el.name] = true;
      });
    setSelected({ ...selected });
  }, [props.value[1]]);

  const handleCheckboxChange = (main: string) => {
    let propsIndex = props.value[1].findIndex((item: any) => item.name == main);
    props.value[1][propsIndex].included = !props.value[1][propsIndex].included;
    let index = props.disclosuresArray.findIndex((item: any) => item == main);
    if (index > -1) {
      if (props.value[1][propsIndex]["comments"] === "") {
        setCurrentDisclosureIndex(
          currentDisclosureIndex > propsIndex
            ? currentDisclosureIndex - 1
            : currentDisclosureIndex
        );
      }
      // remove item from rendering
      props.disclosuresArray.splice(index, 1);
    } else {
      props.disclosuresArray.push(main);
    }
    props.setDisclosuresArray([...props.disclosuresArray]);
    props.update();
  };

  let [selected, setSelected] = useState<any>({});

  const onClickShowComments = (main: string) => {
    if (selected[main]) {
      let index = props.value[1].findIndex((item: any) => item.name == main);
      setCurrentDisclosure(main);
      setCurrentDisclosureIndex(index);
      props.update();
    }
  };

  const handleComments = (e: any) => {
    if (typeof props.value[1][currentDisclosureIndex]["comments"] == "string") {
      props.value[1][currentDisclosureIndex]["comments"] = {
        reason: "",
        reasonType: "",
      };
    }
    props.value[1][currentDisclosureIndex]["comments"].reason = e.target.value;
    props.update();
  };
  const deleteComment = () => {
    props.value[1][currentDisclosureIndex]["comments"] = {
      reason: "",
      reasonType: "",
    };
    props.update();
  };

  return (
    <div className="pb-5">
      {props.allDisclosures.slice(2).map((main: any, index: any) => {
        return (
          <div
            key={index}
            style={{ paddingLeft: "2vw", marginTop: "2.2vh" }}
            className="flex flex-col"
          >
            <div className="flex flex-row items-start justify-between w-full">
              <div className="w-2/3 flex items-center">
                <Checkbox
                  checked={props.disclosuresArray.includes(main)}
                  onChange={() => handleCheckboxChange(main)}
                />
                <span style={{ marginLeft: "8px" }}>{main}</span>
              </div>
              <div className="w-1/3 h-[24px] p-[4px] flex flex-row items-center ">
                <img
                  src="assets/icons/comment-processing-outline.svg"
                  style={{
                    opacity: selected[main] ? 1 : 0.3,
                    cursor: selected[main] ? "pointer" : "not-allowed",
                  }}
                  alt=" "
                  onClick={() => onClickShowComments(main)}
                />
              </div>
            </div>
            <div className="flex flex-row">
              {currentDisclosureIndex != null && currentDisclosure == main ? (
                <div className=" flex justify-between w-5/6 bg-gray-50 mb-2 mt-2 ml-2">
                  <FormControl style={{ width: "20%" }}>
                    <InputLabel>Omission Reason Type</InputLabel>
                    <Select
                      onChange={(e) =>
                        addCommentsReasonType(
                          props.value[1][currentDisclosureIndex],
                          e
                        )
                      }
                      label="Omission Reason Type"
                      value={
                        props.value[1][currentDisclosureIndex].comments
                          .reasonType
                      }
                    >
                      <MenuItem value="Not applicable">Not applicable</MenuItem>
                      <MenuItem value="Legal prohibitions">
                        Legal prohibitions
                      </MenuItem>
                      <MenuItem value="Confidentiality constraints">
                        Confidentiality constraints
                      </MenuItem>
                      <MenuItem value="Information unavailable / incomplete">
                        Information unavailable / incomplete
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    style={{ width: "75%" }}
                    type="text"
                    variant="outlined"
                    value={
                      props.value[1][currentDisclosureIndex]["comments"]
                        .reason == undefined
                        ? props.value[1][currentDisclosureIndex]["comments"]
                        : props.value[1][currentDisclosureIndex]["comments"]
                            .reason
                    }
                    placeholder={t("Add comment")}
                    className="pw-width-100 pw-comments"
                    onChange={handleComments}
                  />
                  <IconButton onClick={(e) => deleteComment()}>
                    <DeleteOutlinedIcon
                      sx={{ color: "red", cursor: "pointer" }}
                    />
                  </IconButton>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DisclosureSelection;
